import { Controller } from "stimulus"
import _map from 'lodash/map'
import Sortable from "sortablejs"

export default class extends Controller
  @targets: [
    'presentationsContainer',
    'presentation' ]

  @values =
    createPresentationUrl: String
    reorderPresentationsUrl: String

  initialize: ->
    new Sortable @presentationsContainerTarget,
      animation: 50
      ghostClass: 'sortable-placeholder-highlight-variable'
      handle: '[role="sort_handle"]'
      swapThreshold: 0.25
      onEnd: (event) =>
        @reorderPresentations(event)
        $(event.item).effect('highlight', {}, 2000)

  fileUploaded: (event) ->
    # Grab a reference to where we expect the blob's info to be.
    blob = event.detail.blob

    # Build the FormData we'll pass along with our request.
    data = new FormData()
    data.append 'blob[signed_id]', blob.signed_id
    data.append 'blob[filename]', blob.filename

    # Submit the blob's info to the EA's presentation create URL.
    Rails.ajax
      type: 'POST'
      url: @createPresentationUrlValue
      dataType: 'script'
      data: data

  reorderPresentations: (event) ->
    orderedIds = _map @presentationTargets, (presentation) -> presentation.dataset.presentationId

    data = new FormData()
    data.append 'ordered_ids', orderedIds

    # Submit the blob's info to the EA's presentation create URL.
    Rails.ajax
      type: 'POST'
      url: @reorderPresentationsUrlValue
      dataType: 'html'
      data: data